import { connect } from "react-redux";
import AppDownloadBanner from "./AppDownloadBanner";
import { getDefaultStoreUrl } from "../../../../state/modules/regionalStore";

const mapStateToProps = state => ({
  defaultStoreUrl: getDefaultStoreUrl(state)
});

export default connect(mapStateToProps)(AppDownloadBanner);
